<template>
  <vjs-modal v-bind="$options.propsData" :name="name" width="500">
    <template slot="body-content">
      <slot v-if="$scopedSlots['default']" />
      <div v-else>
        {{ message }}
      </div>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" />
        <template v-else>
          <i v-if="confirmIcon" :class="confirmIcon" />
        </template>
        {{ confirmText }}
      </b-button>
      <b-button variant="ss-cancel" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" />
        {{ cancelText }}
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `confirm-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'confirm',
    },
    message: {
      type: String,
      required: false,
      default: `Are you sure?`,
    },
    confirmText: {
      type: String,
      required: false,
      default: `Confirm`,
    },
    confirmIcon: {
      type: String,
      required: false,
      default: null,
    },
    cancelText: {
      type: String,
      required: false,
      default: `Cancel`,
    },
  },
  methods: {
    close(confirmed) {
      this.close_data.confirm = confirmed;
      this.complete();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
